import {useSelector} from "react-redux";
import {CHART_FOCUSES, getChartFocus} from "../../../ducks/chart-duck.js";
import Counter from "../../util/Counter.jsx";
import {DECIMAL_FORMAT} from "../../../util/numbers.js";
import './ChartHover.scss'
import DirectionIcon from "../../util/icons/DirectionIcon.jsx";
import GainPct from "../../util/GainPct.jsx";
import {getDirectionColorClassName} from "../../../util/misc.js";
import {getAssetsTotalGain, getAssetsTotalValue, getLatestGainChange} from "../../../ducks/assets-duck.js";

export default () => {

    const chartFocus = useSelector(getChartFocus)
    const gainChange = useSelector(getLatestGainChange)

    const value = useSelector(getAssetsTotalValue)
    const gain = useSelector(getAssetsTotalGain)

    const changePercent = (gainChange / (value - gainChange)) || 0

    const header = gain < 0 ? 'loss' : CHART_FOCUSES[chartFocus].name


    return (
        <div className='chart-hover'>
            <div className='kpis hide-desktop'>
                <KPI
                    className={`focus-value ${value < 0 ? 'is-negative' : ''}`}
                    header={header}
                >
                    {chartFocus === 'gain' ?
                        <Counter
                            amount={gain}
                            absolute={true}
                            decimals={DECIMAL_FORMAT.FLEX}
                        />
                        :
                        <Counter
                            amount={value}
                            absolute={true}
                            decimals={DECIMAL_FORMAT.FLEX}
                        />
                    }
                    {chartFocus === 'gain' &&
                    <div className='pct'>
                        <GainPct
                            value={value}
                            gain={gain}
                        />
                    </div>
                    }
                </KPI>
                <KPI
                    className='change'
                    header={'change'}
                >
                    <div className='arrow'>
                        <DirectionIcon
                            value={changePercent}
                            isMultiColored={true}
                        />
                    </div>
                    <div className='abs'>
                        <Counter
                            amount={gainChange}
                            absolute={true}
                        />
                    </div>
                    <div className={`pct ${getDirectionColorClassName(changePercent, true)}`}>
                        <Counter
                            amount={changePercent * 100}
                            decimals={DECIMAL_FORMAT.FLEX_PERCENTAGE}
                            suffix='%'
                            absolute={true}
                        />
                    </div>
                </KPI>
            </div>
            <div className='kpis hide-portrait'>
                <KPI
                    className={`focus-value ${value < 0 ? 'is-negative' : ''}`}
                    header={'value'}
                >
                    <Counter
                        amount={value}
                        absolute={true}
                    />
                </KPI>
                <KPI
                    header={gain < 0 ? 'loss' : 'return'}
                >
                    <div>
                        <Counter
                            amount={gain}
                            absolute={true}
                        />
                    </div>
                    <div className='pct'>
                        <GainPct
                            value={value}
                            gain={gain}
                        />
                    </div>
                </KPI>
                <KPI
                    className='change'
                    header={'change'}
                >
                    <div className='arrow'>
                        <DirectionIcon
                            value={changePercent}
                            isMultiColored={true}
                        />
                    </div>
                    <div className='abs'>
                        <Counter
                            amount={gainChange}
                            absolute={true}
                        />
                    </div>
                    <div className={`pct ${getDirectionColorClassName(changePercent, true)}`}>
                        <Counter
                            amount={changePercent * 100}
                            decimals={DECIMAL_FORMAT.FLEX_PERCENTAGE}
                            suffix='%'
                            absolute={true}
                        />
                    </div>
                </KPI>
            </div>
        </div>
    )
}

const KPI = ({header, className = "", children}) => {
    return (
        <div className={`kpi ${className}`}>
            <h3>
                {header}
            </h3>
            <div className={`kpi-value`}>
                {children}
            </div>
        </div>
    )
}